// import hooks
import { useState } from "react";
import useDebounce from "../../../../hooks/useDebounce/useDebounce.hook.js";
export const useSearchControlledValue = ({ defaultValue = "", onSearch, delay, onChange, }) => {
    const [searchValue, setSearchValue] = useState(defaultValue);
    useDebounce(searchValue, { delay, onDebounce: onSearch });
    return {
        searchValue,
        setSearchValue,
        onChangeHandler: (e) => {
            setSearchValue(e.currentTarget.value ?? "");
            onChange?.(e);
        },
        resetSearchValue: () => setSearchValue(""),
    };
};
export default useSearchControlledValue;
